import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

export const SortingBar = styled.div<IProps>`
  ${mixin.flex({ justify: 'space-between' })};
  padding: 16px;

  .time-txt {
    ${mixin.flex({ align: 'center' })};
    line-height: 130%;
    font-size: 13px;
    color: #999;

    svg {
      transform: scale(0.8);
    }
  }

  .noti-txt {
    line-height: 130%;
    font-size: 16px;
    font-weight: 400;
    color: #acacac;
  }

  .chk-item {
    svg {
      width: 16px;
      height: 16px;
    }

    .label {
      font-size: 13px;
      margin-left: 6px;
      color: #555;
    }
  }

  .btn-item {
    ${mixin.flex({ justify: 'space-between' })};
    column-gap: 12px;

    .btn {
      position: relative;
      font-size: 13px;
      color: #555;

      &:nth-child(2n):after {
        content: '';
        position: absolute;
        top: 0;
        left: -6px;
        width: 1px;
        height: 12px;
        background-color: #e2e2e2;
      }
    }
  }

  .area-sorting {
    margin-left: auto;
    ${mixin.flex({ justify: 'flex-end' })};
    column-gap: 12px;
  }

  .area-toggle {
    ${mixin.flex({})};
    margin-left: 8px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('16')};

    .time-txt {
      font-size: ${mixin.pxToVw('13')};
    }

    .chk-item {
      svg {
        width: ${mixin.pxToVw('16')};
        height: ${mixin.pxToVw('16')};
      }

      .label {
        font-size: ${mixin.pxToVw('13')};
        margin-left: ${mixin.pxToVw('6')};
      }
    }

    .area-sorting {
      column-gap: ${mixin.pxToVw('12')};
    }

    .area-toggle {
      margin-left: ${mixin.pxToVw('8')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 0 0 20px 0;

    /* 위에 LP 필터바가 있으면 필터바와의 간격이 필요해 위쪽 여백도 준다.
       sale은 필터바가 .area-menu 안에 있어서 앞 형제가 .area-menu다 */
    .lp-filter-bar + &,
    .area-menu:has(.lp-filter-bar) + & {
      padding: 36px 0 20px 0;
    }

    /* 선택칩 행(.area-selected)이 있으면 그만큼 더 띄운다 */
    .lp-filter-bar:has(.pin-area .area-selected) + &,
    .area-menu:has(.lp-filter-bar .pin-area .area-selected) + & {
      padding: 48px 0 20px 0;
    }

    .time-txt {
      font-size: 16px;

      svg {
        margin-right: 2.7px;
      }
    }

    .chk-item {
      svg {
        width: 20px;
        height: 20px;
      }

      .label {
        font-size: 16px;
        margin-left: 8px;
      }

      .checkbox + .checkbox {
        margin-left: 6px;
      }
    }

    .area-sorting {
      column-gap: 20px;
    }
  }
`;
